"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAdaptiveCardMiddleware;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardAttachment = _interopRequireDefault(require("./Attachment/AdaptiveCardAttachment"));

var _AnimationCardAttachment = _interopRequireDefault(require("./Attachment/AnimationCardAttachment"));

var _AudioCardAttachment = _interopRequireDefault(require("./Attachment/AudioCardAttachment"));

var _HeroCardAttachment = _interopRequireDefault(require("./Attachment/HeroCardAttachment"));

var _OAuthCardAttachment = _interopRequireDefault(require("./Attachment/OAuthCardAttachment"));

var _ReceiptCardAttachment = _interopRequireDefault(require("./Attachment/ReceiptCardAttachment"));

var _SignInCardAttachment = _interopRequireDefault(require("./Attachment/SignInCardAttachment"));

var _ThumbnailCardAttachment = _interopRequireDefault(require("./Attachment/ThumbnailCardAttachment"));

var _VideoCardAttachment = _interopRequireDefault(require("./Attachment/VideoCardAttachment")); // TODO: [P4] Rename this file or the whole middleware, it looks either too simple or too comprehensive now


function createAdaptiveCardMiddleware(props) {
  return function () {
    return function (next) {
      function AdaptiveCardMiddleware(_ref) {
        var activity = _ref.activity,
            attachment = _ref.attachment;
        return attachment.contentType === 'application/vnd.microsoft.card.hero' ? _react.default.createElement(_HeroCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.adaptive' ? _react.default.createElement(_AdaptiveCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.animation' ? _react.default.createElement(_AnimationCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.audio' ? _react.default.createElement(_AudioCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.oauth' ? _react.default.createElement(_OAuthCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.receipt' ? _react.default.createElement(_ReceiptCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.signin' ? _react.default.createElement(_SignInCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.thumbnail' ? _react.default.createElement(_ThumbnailCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : attachment.contentType === 'application/vnd.microsoft.card.video' ? _react.default.createElement(_VideoCardAttachment.default, (0, _extends2.default)({}, props, {
          activity: activity,
          attachment: attachment
        })) : next({
          activity: activity,
          attachment: attachment
        });
      }

      AdaptiveCardMiddleware.propTypes = {
        activity: _propTypes.default.any.isRequired,
        attachment: _propTypes.default.shape({
          contentType: _propTypes.default.string.isRequired
        }).isRequired
      };
      return AdaptiveCardMiddleware;
    };
  };
}